import React from 'react';

export const NotFound = ({ children, ...props }) => {
    if (typeof props.found !== 'undefined' && !props.found) {
        return <div><h1>Not Found</h1></div>
    }

    return (children || null)
};


// WEBPACK FOOTER //
// ./src/components/NotFound.js